import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { ReactComponent as ChevronRightSVG } from "../../../../../../../images/svg/public/order/chevron-right.svg";
import { OrderContext } from "../../../contexts/OrderContext";

interface Props {
	tipAmount: number | null;
	title: string;
	description?: string;
}

const OrderTipTipsItem = ({ tipAmount, title, description }: Props) => {
	const history = useHistory();
	const { matchUrl } = useContext(OrderContext);

	const handleOnClick = () => {
		if (tipAmount === null) {
			history.push(`${matchUrl}/custom_tip`);
		} else {
			history.push(`${matchUrl}/payment?tipAmount=${tipAmount}`);
		}
	};

	return (
		<div className="order-tips-item" data-testid="e-order-tips-item" onClick={handleOnClick}>
			<div className="d-flex flex-column align-items-start">
				<h1 className="mb-0" data-testid={`tip-title-${tipAmount ?? "custom"}`}>
					{title}
				</h1>
				{description && (
					<p className="mb-0 text-muted" data-testid="tip-description">
						{description}
					</p>
				)}
			</div>
			<ChevronRightSVG />
		</div>
	);
};

export default OrderTipTipsItem;
